<template>
  <div>
    <h3>Are you on medication to manage your diabetic risk?</h3>
    <v-form-group class="card-selector" :validator="$v.medicationStatus">
      <b-form-radio v-model="survey.medicationStatus" name="medication" :value=medicationType.Yes>Yes</b-form-radio>
      <b-form-radio v-model="survey.medicationStatus" name="medication" :value=medicationType.No>No</b-form-radio>
      <b-form-radio v-model="survey.medicationStatus" name="medication" :value=medicationType.NotApplicable>Not applicable</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import medicationType from "enums/medication-type";

  export default {
    mixins: [formMixin],
    data() {
      return {
        medicationType: medicationType,
      };
    },

    validations: {
      medicationStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      medicationStatus() { return this.survey.medicationStatus }
    },

    methods: {
      onSubmit() {

      }
    }
  };
</script>